import { render } from "./AppealDetails.vue?vue&type=template&id=4ab8da32"
import script from "./AppealDetails.vue?vue&type=script&lang=js"
export * from "./AppealDetails.vue?vue&type=script&lang=js"

import "./AppealDetails.vue?vue&type=style&index=0&id=4ab8da32&lang=css"

import exportComponent from "D:\\Abdullah\\Projects\\R-Sport\\System\\rsport_dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__